export enum LoadRangeDisplayCma {
    TODAY = 'TODAY',
    YESTERDAY_TO_TOMORROW = 'YESTERDAY_TO_TOMORROW',
    ONE_WEEK_BEFORE_AND_AFTER = 'ONE_WEEK_BEFORE_AND_AFTER',
    ALL = 'ALL'
  }